import { useState } from "react";
import JsonHelper from "../../utils/jsonHelper";

const useSessionStorageConfig = (prefix, id) => {
    const key = `${prefix}_${id}`;
    const [value, _setValue] = useState(() => {
        const value = window.sessionStorage.getItem(key);
        return JsonHelper.isJsonString(value) ? JSON.parse(value) : "";
    });

    const setValue = (newValue) => {
        try {
            window.sessionStorage.setItem(key, JSON.stringify(newValue, null, '\t'));
            _setValue(newValue);
        }
        catch (error) {
            if (error.name === 'QuotaExceededError') {
                Object.keys(window.sessionStorage).forEach(k => {
                    if (!k.includes(key.split('_')[1])) {
                        if (k.includes('initialBuildTimeConfig') || k.includes('buildTimeConfig') || k.includes('templateConfig') || k.includes('templateMetadata')) {
                            window.sessionStorage.removeItem(k);
                        }
                    }
                })

                window.sessionStorage.setItem(key, JSON.stringify(newValue, null, '\t'));
                _setValue(newValue);
            }
        }
    }

    return [value, setValue];
}

const useInitialBuildTimeConfig = (id) => useSessionStorageConfig('initialBuildTimeConfig', id);
const useBuildTimeConfig = (id) => useSessionStorageConfig('buildTimeConfig', id);
const useTemplateConfig = (id) => useSessionStorageConfig('templateConfig', id);
const useTemplateMetadata = (id) => useSessionStorageConfig('templateMetadata', id);

export {
    useInitialBuildTimeConfig,
    useBuildTimeConfig,
    useTemplateConfig,
    useTemplateMetadata
}
